import React from 'react';
import StarRow from './StarRow';

const VoiceCard = ({ voice, tone }) => (
  <article className={`fi-voice-card fi-voice-${tone}`}>
    <div className="fi-voice-top">
      <span className="fi-voice-name">{voice.name || 'Anonymous'}</span>
      <StarRow value={voice.rating} size={14} />
    </div>
    <p className="fi-voice-comment">{voice.comment}</p>
  </article>
);

const VoicesPanel = ({ criticalVoices = [], positiveVoices = [] }) => (
  <div className="fi-voices-grid">
    <section className="fi-card fi-section-card">
      <header className="fi-section-header">
        <span className="fi-section-icon" aria-hidden="true">👎</span>
        <div>
          <h3 className="fi-section-title fi-title-critical">Critical Voices</h3>
          <p className="fi-section-subtitle">≤ 3★ (Q7)</p>
        </div>
      </header>
      {criticalVoices.length === 0 ? (
        <p className="fi-empty-inline">No critical comments for this event.</p>
      ) : (
        <div className="fi-voice-list">
          {criticalVoices.map((voice, index) => (
            <VoiceCard
              key={`critical-${voice.name}-${index}`}
              voice={voice}
              tone="critical"
            />
          ))}
        </div>
      )}
    </section>

    <section className="fi-card fi-section-card">
      <header className="fi-section-header">
        <span className="fi-section-icon" aria-hidden="true">👍</span>
        <div>
          <h3 className="fi-section-title fi-title-positive">Positive Voices</h3>
          <p className="fi-section-subtitle">≥ 4★ (Q7)</p>
        </div>
      </header>
      {positiveVoices.length === 0 ? (
        <p className="fi-empty-inline">No positive comments for this event.</p>
      ) : (
        <div className="fi-voice-list">
          {positiveVoices.map((voice, index) => (
            <VoiceCard
              key={`positive-${voice.name}-${index}`}
              voice={voice}
              tone="positive"
            />
          ))}
        </div>
      )}
    </section>
  </div>
);

export default VoicesPanel;
